import React, { useState, useEffect } from 'react'
import { useFetch } from '../../../../components/component-items/helpers'

// Components
import GlobalStyles from '../../../../components/component-items/styles'
import { TableCell } from '../../../../components/component-items/datatable'
import CardLoading from '../../../../components/component-items/loading-popover'
import { TableRow } from '../styles'

// Types
import type { LogisticUnitTransaction } from '../types'

const formatTransactionDetails = (tx: LogisticUnitTransaction): string => {
  switch (tx.transaction_type) {
    case 'create':
      return tx.to_location_barcode ? `Created at ${tx.to_location_barcode}` : 'Created'
    case 'move':
      return `Moved from ${tx.from_location_barcode || '\u2014'} to ${tx.to_location_barcode || '\u2014'}`
    case 'nest':
      return `Nested under ${tx.to_parent_lpn || '\u2014'}`
    case 'unnest':
      return `Unnested from ${tx.from_parent_lpn || '\u2014'}`
    case 'retire':
      return 'Retired'
    case 'add_item':
      return tx.to_location_barcode ? `Item added at ${tx.to_location_barcode}` : 'Item added'
    case 'remove_item':
      return tx.from_location_barcode ? `Item removed at ${tx.from_location_barcode}` : 'Item removed'
    default:
      return tx.transaction_type_display || tx.transaction_type
  }
}

type HistoryTabProps = {
  lpn: string
}

export const HistoryTab = ({ lpn }: HistoryTabProps) => {
  const url = `/api/inventory/logistic-unit/${lpn}/transactions/`
  const res: any = useFetch(url, {})
  const transactions: LogisticUnitTransaction[] = res.loaded ? res.response.results || res.response || [] : []

  return (
    <div style={{ position: 'relative', minHeight: 200 }}>
      {transactions.length > 0 ? (
        <GlobalStyles.DataTable>
          <thead>
            <tr>
              <th>
                <span className="text">Date</span>
              </th>
              <th>
                <span className="text center">Type</span>
              </th>
              <th>
                <span className="text">Details</span>
              </th>
              <th>
                <span className="text">User</span>
              </th>
              <th>
                <span className="text">Comment</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((tx: LogisticUnitTransaction) => (
              <TableRow key={tx.id}>
                <TableCell input={new Date(tx.created).toLocaleString()} />
                <TableCell center input={tx.transaction_type_display} />
                <TableCell input={formatTransactionDetails(tx)} />
                <TableCell input={tx.user_username || '\u2014'} />
                <TableCell input={tx.comment || '\u2014'} />
              </TableRow>
            ))}
          </tbody>
        </GlobalStyles.DataTable>
      ) : res.loaded ? (
        <p style={{ color: '#74788d', fontStyle: 'italic', padding: '1rem 0' }}>No transaction history.</p>
      ) : null}
      {!res.loaded ? <CardLoading text={res.placeholder} error={res.error} /> : null}
    </div>
  )
}

export default HistoryTab
